module.exports = __webpack_public_path__ + "static/banner-brown-ef71cf62bc2915d1a9f95c052c0d58e4.svg";